var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWiperWh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(65 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.2,24.936a.75.75,0,0,1-.2-.027,28.423,28.423,0,0,0-15,0,.75.75,0,0,1-.882-.415c-1.661-3.677-3.42-7.489-5.534-12a.75.75,0,0,1,.339-.987,29.913,29.913,0,0,1,27.157,0,.75.75,0,0,1,.339.987c-2.115,4.506-3.873,8.318-5.534,12A.75.75,0,0,1,90.2,24.936ZM82.5,22.4a29.921,29.921,0,0,1,7.277.9c1.5-3.323,3.1-6.778,4.97-10.772a28.411,28.411,0,0,0-24.494,0c1.871,3.993,3.465,7.448,4.97,10.772A29.921,29.921,0,0,1,82.5,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.2,24.936a.75.75,0,0,1-.2-.027,28.423,28.423,0,0,0-15,0,.75.75,0,0,1-.882-.415c-1.661-3.677-3.42-7.489-5.534-12a.75.75,0,0,1,.339-.987,29.913,29.913,0,0,1,27.157,0,.75.75,0,0,1,.339.987c-2.115,4.506-3.873,8.318-5.534,12A.75.75,0,0,1,90.2,24.936ZM82.5,22.4a29.921,29.921,0,0,1,7.277.9c1.5-3.323,3.1-6.778,4.97-10.772a28.411,28.411,0,0,0-24.494,0c1.871,3.993,3.465,7.448,4.97,10.772A29.921,29.921,0,0,1,82.5,22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.82,10.472a.75.75,0,0,1-.644-.365L-.644.385A.75.75,0,0,1-.385-.644.75.75,0,0,1,.644-.385L6.463,9.337a.75.75,0,0,1-.643,1.135Z",
    transform: "translate(75.167 16.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.82,10.472a.75.75,0,0,1-.644-.365L-.644.385A.75.75,0,0,1-.385-.644.75.75,0,0,1,.644-.385L6.463,9.337a.75.75,0,0,1-.643,1.135Z",
    transform: "translate(80.434 16.275)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWiperWh);
export default __webpack_public_path__ + "static/media/icon_wiper_wh.0a9c7d0372161f72c2100efa7f596476.svg";
export { ForwardRef as ReactComponent };